/**
 * Bolsa.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnumEstadoBolsaCurso = 0 | 1;

export const EnumEstadoBolsaCurso = {
    NUMBER_0: 0 as EnumEstadoBolsaCurso,
    NUMBER_1: 1 as EnumEstadoBolsaCurso
};

